<h3 mat-dialog-title>{{(data.title | titlecase) || ('are you sure?' | translate | titlecase )}}</h3>

<div mat-dialog-content class="mat-body">
    <p>{{ data.message }}</p>
</div>

<div mat-dialog-actions>
    <button mat-stroked-button color="primary" [mat-dialog-close]="false">{{'no' | translate | uppercase}}</button>
    <button mat-flat-button color="primary" cdkFocusInitial [mat-dialog-close]="true">{{'yes' | translate | uppercase}}</button>
</div>